export enum RadioGroupEnum {
    None,
    Price,
}